import { render, staticRenderFns } from "./XianshangXingweiFenxiDetail.vue?vue&type=template&id=72ea995c&scoped=true&"
import script from "./XianshangXingweiFenxiDetail.vue?vue&type=script&lang=js&"
export * from "./XianshangXingweiFenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./XianshangXingweiFenxiDetail.vue?vue&type=style&index=0&id=72ea995c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea995c",
  null
  
)

export default component.exports